
<div id="print-area" class="capture-area">
    <div *ngIf="isViewMode" class="view-mode-controls">
        <ion-button (click)="goBackToSettings()" fill="clear" color="light" class="back-button">
            <ion-icon name="arrow-back" slot="icon-only"></ion-icon>
        </ion-button>
        <ion-button (click)="previousPage()" [disabled]="currentStageIndex === 0">Previous Page</ion-button>
        <span style="color: white; margin: 0 20px;">Page {{ currentStageIndex + 1 }} of {{ orderedStages.length }}</span>
        <ion-button (click)="nextPage()" [disabled]="currentStageIndex === orderedStages.length - 1">Next Page</ion-button>
        <ion-input
                class="page-jump-input"
                type="number"
                min="1"
                [max]="orderedStages.length"
                [(ngModel)]="targetPageNumber"
                (keyup.enter)="jumpToPage()">
        </ion-input>
        <ion-button (click)="jumpToPage()">Jump</ion-button>
        <ion-button (click)="toggleMetrics()" color="secondary">{{ metricsEnabled ? 'Hide Metrics' : 'Show Metrics' }}</ion-button>
    </div>
    <div *ngIf="!isViewMode && pdfGenerated" class="view-mode-controls pdf-done">
        <ion-button (click)="goBackToSettings()" fill="clear" color="light" class="back-button">
            <ion-icon name="arrow-back" slot="icon-only"></ion-icon>
        </ion-button>
        <span style="color: white; margin-left: 10px;">PDF Generation Complete</span>
        <ion-button (click)="exportPDF()" color="success" style="margin-left: 20px;">Export PDF</ion-button>
    </div>
    <div class="rendered-page-container" [class.not-matched]="isViewMode && !pageMatched" *ngIf="isRendered">
        <app-precision
                [elementConfig]="elementConfig"
                [pageConfig]="pageConfig"
                [state]="state"
                [languageStore]="languageStore">
        </app-precision>
    </div>

    <div class="extra-info" *ngIf="showFirstPageOverview">
        <div class="status-bar">
            <div class="status-item summary" style="background: none; border: none; padding-left: 0;">
                <span class="label" style="color: white;">Summary</span>
            </div>
            <div class="status-item" [class.success]="totalIssuesCount === 0" [class.error]="totalIssuesCount > 0">
                <span class="label">Issues:</span>
                <span class="count-badge">#{{ totalIssuesCount }}</span>
            </div>
            <div class="status-item" *ngIf="checkerSettings.enableComparison" [class.success]="totalChangesCount === 0" [class.highlight]="totalChangesCount > 0">
                <span class="label">Changes:</span>
                <span class="count-badge">#{{ totalChangesCount }}</span>
            </div>
            <div class="status-item" [class.success]="newPageCount === 0" [class.highlight]="newPageCount > 0">
                <span class="label">New Pages:</span>
                <span class="value">{{ newPageCount }}</span>
            </div>
            <div class="status-item" [class.success]="changedPageCount === 0" [class.highlight]="changedPageCount > 0">
                <span class="label">Changed Pages:</span>
                <span class="value">{{ changedPageCount }}</span>
            </div>
        </div>
        <h3>Config: {{ configName }}</h3>
        <h4 class="issues-label">Issues:</h4>

        <div class="metric-header" *ngIf="unreachablePages && unreachablePages.length > 0">
            <h4>Unreachable Pages:</h4>
            <span class="count-badge">#{{ unreachableCount }}</span>
        </div>
        <ul class="chips-list" *ngIf="unreachablePages && unreachablePages.length > 0">
            <li *ngFor="let page of unreachablePages | slice:0:(isOverviewSectionExpanded('unreachable-pages') ? unreachablePages.length : itemDisplayAmount)" class="chip error">{{ page }}</li>
            <li *ngIf="unreachablePages.length > itemDisplayAmount" class="chip-toggle">
                <button type="button" class="chip overview-toggle" (click)="toggleOverviewSection('unreachable-pages')" [attr.aria-expanded]="isOverviewSectionExpanded('unreachable-pages')">
                    {{ isOverviewSectionExpanded('unreachable-pages') ? '<' : '...' }}
                </button>
            </li>
        </ul>

        <div class="metric-header" *ngIf="deadEndPages && deadEndPages.length > 0">
            <h4>Dead End Pages:</h4>
            <span class="count-badge">#{{ deadEndCount }}</span>
        </div>
        <ul class="chips-list" *ngIf="deadEndPages && deadEndPages.length > 0">
            <li *ngFor="let page of deadEndPages | slice:0:(isOverviewSectionExpanded('dead-end-pages') ? deadEndPages.length : itemDisplayAmount)" class="chip error">{{ page }}</li>
            <li *ngIf="deadEndPages.length > itemDisplayAmount" class="chip-toggle">
                <button type="button" class="chip overview-toggle" (click)="toggleOverviewSection('dead-end-pages')" [attr.aria-expanded]="isOverviewSectionExpanded('dead-end-pages')">
                    {{ isOverviewSectionExpanded('dead-end-pages') ? '<' : '...' }}
                </button>
            </li>
        </ul>

        <div *ngFor="let lang of languageMetrics | keyvalue">
            <h4 style="margin-top: 20px; border-bottom: 1px solid #ccc; padding-bottom: 5px;">Dictionary - {{ lang.key }}</h4>

            <div class="metric-header" *ngIf="lang.value.missing_keys && lang.value.missing_keys.length > 0">
                <span class="label" style="font-weight: bold; color: #000;">Missing Keys:</span>
                <span class="count-badge">#{{ lang.value.missing_keys_count }}</span>
            </div>
            <ul class="chips-list" *ngIf="lang.value.missing_keys && lang.value.missing_keys.length > 0">
                <li *ngFor="let key of lang.value.missing_keys | slice:0:(isOverviewSectionExpanded('missing-keys-' + lang.key) ? lang.value.missing_keys.length : itemDisplayAmount)" class="chip error">{{ key }}</li>
                <li *ngIf="lang.value.missing_keys.length > itemDisplayAmount" class="chip-toggle">
                    <button type="button" class="chip overview-toggle" (click)="toggleOverviewSection('missing-keys-' + lang.key)" [attr.aria-expanded]="isOverviewSectionExpanded('missing-keys-' + lang.key)">
                        {{ isOverviewSectionExpanded('missing-keys-' + lang.key) ? '<' : '...' }}
                    </button>
                </li>
            </ul>

            <div class="metric-header" *ngIf="lang.value.missing_value_keys && lang.value.missing_value_keys.length > 0">
                <span class="label" style="font-weight: bold; color: #000;">Missing Values:</span>
                <span class="count-badge">#{{ lang.value.missing_values_count }}</span>
            </div>
            <ul class="chips-list" *ngIf="lang.value.missing_value_keys && lang.value.missing_value_keys.length > 0">
                <li *ngFor="let key of lang.value.missing_value_keys | slice:0:(isOverviewSectionExpanded('missing-values-' + lang.key) ? lang.value.missing_value_keys.length : itemDisplayAmount)" class="chip error">{{ key }}</li>
                <li *ngIf="lang.value.missing_value_keys.length > itemDisplayAmount" class="chip-toggle">
                    <button type="button" class="chip overview-toggle" (click)="toggleOverviewSection('missing-values-' + lang.key)" [attr.aria-expanded]="isOverviewSectionExpanded('missing-values-' + lang.key)">
                        {{ isOverviewSectionExpanded('missing-values-' + lang.key) ? '<' : '...' }}
                    </button>
                </li>
            </ul>
        </div>
        <ng-container *ngIf="checkerSettings.enableComparison">
            <h4 class="changes-label">Changes:</h4>
            <div class="metric-header" *ngIf="newPages && newPages.length > 0">
                <h4>New Pages:</h4>
                <span class="count-badge">#{{ newPages.length }}</span>
            </div>
            <ul class="chips-list" *ngIf="newPages && newPages.length > 0">
                <li *ngFor="let page of newPages | slice:0:(isOverviewSectionExpanded('new-pages') ? newPages.length : itemDisplayAmount)" class="chip highlight">{{ page }}</li>
                <li *ngIf="newPages.length > itemDisplayAmount" class="chip-toggle">
                    <button type="button" class="chip overview-toggle" (click)="toggleOverviewSection('new-pages')" [attr.aria-expanded]="isOverviewSectionExpanded('new-pages')">
                        {{ isOverviewSectionExpanded('new-pages') ? '<' : '...' }}
                    </button>
                </li>
            </ul>

            <div class="metric-header" *ngIf="changedPages && changedPages.length > 0">
                <h4>Changed Pages:</h4>
                <span class="count-badge">#{{ changedPages.length }}</span>
            </div>
            <ul class="chips-list" *ngIf="changedPages && changedPages.length > 0">
                <li *ngFor="let page of changedPages | slice:0:(isOverviewSectionExpanded('changed-pages') ? changedPages.length : itemDisplayAmount)" class="chip highlight">{{ page }}</li>
                <li *ngIf="changedPages.length > itemDisplayAmount" class="chip-toggle">
                    <button type="button" class="chip overview-toggle" (click)="toggleOverviewSection('changed-pages')" [attr.aria-expanded]="isOverviewSectionExpanded('changed-pages')">
                        {{ isOverviewSectionExpanded('changed-pages') ? '<' : '...' }}
                    </button>
                </li>
            </ul>

            <div class="metric-header" *ngIf="changedSettings && changedSettings.length > 0">
                <h4>Changed Settings:</h4>
                <span class="count-badge">#{{ changedSettings.length }}</span>
            </div>
            <ul class="chips-list" *ngIf="changedSettings && changedSettings.length > 0">
                <li *ngFor="let setting of changedSettings | slice:0:(isOverviewSectionExpanded('changed-settings') ? changedSettings.length : itemDisplayAmount)" class="chip highlight">{{ setting }}</li>
                <li *ngIf="changedSettings.length > itemDisplayAmount" class="chip-toggle">
                    <button type="button" class="chip overview-toggle" (click)="toggleOverviewSection('changed-settings')" [attr.aria-expanded]="isOverviewSectionExpanded('changed-settings')">
                        {{ isOverviewSectionExpanded('changed-settings') ? '<' : '...' }}
                    </button>
                </li>
            </ul>

            <div class="metric-header" *ngIf="changedTemplates && changedTemplates.length > 0">
                <h4>Changed Templates:</h4>
                <span class="count-badge">#{{ changedTemplates.length }}</span>
            </div>
            <ul class="chips-list" *ngIf="changedTemplates && changedTemplates.length > 0">
                <li *ngFor="let template of changedTemplates | slice:0:(isOverviewSectionExpanded('changed-templates') ? changedTemplates.length : itemDisplayAmount)" class="chip highlight">{{ template }}</li>
                <li *ngIf="changedTemplates.length > itemDisplayAmount" class="chip-toggle">
                    <button type="button" class="chip overview-toggle" (click)="toggleOverviewSection('changed-templates')" [attr.aria-expanded]="isOverviewSectionExpanded('changed-templates')">
                        {{ isOverviewSectionExpanded('changed-templates') ? '<' : '...' }}
                    </button>
                </li>
            </ul>

            <div class="metric-header" *ngIf="changedTemplatesElements && changedTemplatesElements.length > 0">
                <h4>Changed Templates Elements:</h4>
                <span class="count-badge">#{{ changedTemplatesElements.length }}</span>
            </div>
            <ul class="chips-list" *ngIf="changedTemplatesElements && changedTemplatesElements.length > 0">
                <li *ngFor="let element of changedTemplatesElements | slice:0:(isOverviewSectionExpanded('changed-template-elements') ? changedTemplatesElements.length : itemDisplayAmount)" class="chip highlight">{{ element }}</li>
                <li *ngIf="changedTemplatesElements.length > itemDisplayAmount" class="chip-toggle">
                    <button type="button" class="chip overview-toggle" (click)="toggleOverviewSection('changed-template-elements')" [attr.aria-expanded]="isOverviewSectionExpanded('changed-template-elements')">
                        {{ isOverviewSectionExpanded('changed-template-elements') ? '<' : '...' }}
                    </button>
                </li>
            </ul>

            <div *ngFor="let lang of changedLanguages | keyvalue">
                <div class="metric-header" *ngIf="lang.value && lang.value.length > 0">
                    <h4 style="margin-top: 20px;">Changes - Dictionary {{ lang.key }}:</h4>
                    <span class="count-badge">#{{ lang.value.length }}</span>
                </div>
                <ul class="chips-list" *ngIf="lang.value && lang.value.length > 0">
                    <li *ngFor="let key of lang.value | slice:0:(isOverviewSectionExpanded('changed-language-' + lang.key) ? lang.value.length : itemDisplayAmount)" class="chip highlight">{{ key }}</li>
                    <li *ngIf="lang.value.length > itemDisplayAmount" class="chip-toggle">
                        <button type="button" class="chip overview-toggle" (click)="toggleOverviewSection('changed-language-' + lang.key)" [attr.aria-expanded]="isOverviewSectionExpanded('changed-language-' + lang.key)">
                            {{ isOverviewSectionExpanded('changed-language-' + lang.key) ? '<' : '...' }}
                        </button>
                    </li>
                </ul>
            </div>
        </ng-container>
    </div>

    <div class="extra-info" *ngIf="showOverlay" [class.view-mode]="isViewMode">
        <div class="status-bar">
            <div class="status-item" [class.success]="isReached || currentStage === intentionallyUnreachablePage" [class.error]="!isReached && currentStage !== intentionallyUnreachablePage">
                <span class="label">Reached:</span>
                <span class="value">{{ (isReached || currentStage === intentionallyUnreachablePage) ? 'Yes' : 'No' }}</span>
            </div>
            <div class="status-item" [class.success]="!isDeadEnd || currentStage === intentionallyDeadEndPage" [class.error]="isDeadEnd && currentStage !== intentionallyDeadEndPage">
                <span class="label">Dead End:</span>
                <span class="value">{{ (isDeadEnd && currentStage !== intentionallyDeadEndPage) ? 'Yes' : 'No' }}</span>
            </div>
            <div class="status-item neutral">
                <span class="label">Rendered:</span>
                <span class="value">{{ isRendered ? 'Yes' : 'No' }}</span>
            </div>
            <div class="status-item" *ngIf="checkerSettings.enableComparison" [class.success]="!isNewPage" [class.highlight]="isNewPage">
                <span class="label">New Page:</span>
                <span class="value">{{ isNewPage ? 'Yes' : 'No' }}</span>
            </div>
            <div class="status-item" *ngIf="checkerSettings.enableComparison" [class.success]="!isChangedPage" [class.highlight]="isChangedPage">
                <span class="label">Changed Page:</span>
                <span class="value">{{ isChangedPage ? 'Yes' : 'No' }}</span>
            </div>
            <div class="status-item neutral" *ngIf="checkerSettings.checkerMode === 'appPath' && currentPathName">
                <span class="label">Current Path:</span>
                <span class="value">{{ currentPathName }}</span>
            </div>
        </div>
        <h3>Page: {{ currentStage }}</h3>

        <div class="metric-header">
            <h4>Inputs:</h4>
            <span class="count-badge">#{{ numberOfInputs }}</span>
        </div>
        <ul class="chips-list" *ngIf="pageInputs && pageInputs.length > 0">
            <li *ngFor="let input of pageInputs" class="chip">{{ input }}</li>
        </ul>

        <div class="metric-header">
            <h4>Outputs:</h4>
            <span class="count-badge">#{{ numberOfOutputs }}</span>
        </div>
        <ul class="chips-list" *ngIf="pageOutputs && pageOutputs.length > 0">
            <li *ngFor="let output of pageOutputs" class="chip">{{ output }}</li>
        </ul>

    </div>
</div>
